import {ReposHeaderRefSelector} from '@github-ui/code-view-shared/components/ReposHeaderRefSelector'
import {ArrowUpIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {clsx} from 'clsx'

import styles from './FileNameStickyHeader.module.css'
import {ReposHeaderBreadcrumb} from './ReposHeaderBreadcrumb'

const StickyReposHeaderBreadcrumb = () => {
  // additional ids to create unique ids for axe
  return (
    <ReposHeaderBreadcrumb
      id="sticky-breadcrumb"
      fileNameId="sticky-file-name-id"
      size="md"
      showCopyPathButton
      copyButtonTooltipDirection="s"
    />
  )
}

const GoToTopButton = ({className}: {className?: string}) => {
  return (
    <Button
      leadingVisual={ArrowUpIcon}
      variant="invisible"
      size="small"
      onClick={event => {
        event.preventDefault()
        window.scrollTo({top: 0, behavior: 'smooth'})
      }}
      className={clsx(styles.Button, className)}
    >
      Top
    </Button>
  )
}

export default function FileNameStickyHeader({
  isStickied,
  showTree,
  treeToggleElement,
}: {
  isStickied: boolean
  showTree: boolean
  treeToggleElement: React.ReactElement | null
}) {
  return (
    <div
      className={clsx(
        styles.outerWrapper,
        isStickied ? styles.outerWrapperVisible : styles.outerWrapperHidden,
        isStickied && styles.outerWrapperStickied,
      )}
    >
      {!showTree ? (
        <div className={styles.Box_1}>
          <div className={styles.Box_2}>
            {isStickied && treeToggleElement}
            <div className={styles.Box_3}>
              <ReposHeaderRefSelector buttonClassName="ref-selector-class" />
            </div>
            <div className={styles.Box_4}>
              <StickyReposHeaderBreadcrumb />
            </div>
          </div>
          <GoToTopButton className={styles.GoToTopButton} />
        </div>
      ) : (
        <div className={styles.Box_5}>
          <StickyReposHeaderBreadcrumb />
          <GoToTopButton className={styles.GoToTopButton} />
        </div>
      )}
    </div>
  )
}
